export enum GROUP_TYPE {
    INDIVIDUAL = 'individual',
    GROUP = 'group',
}
